function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAppLastSession, editAppLastSessionField, fetchAppUpdateLastSession, editAndUpdateAppLastSession } from './actions';
export function withAppLastSession(WrappedComponent, options) {
  var appName = options.app;
  var withAppLastSessionComponent = function (_Component) {
    _inherits(withAppLastSessionComponent, _Component);
    var _super = _createSuper(withAppLastSessionComponent);
    function withAppLastSessionComponent() {
      var _this;
      _classCallCheck(this, withAppLastSessionComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "handleEditAppLastSession", function (status, fields) {
        var appLastSessionActions = _this.props.appLastSessionActions;
        var token = _this.props.impersonate.token;
        appLastSessionActions.editAndUpdateAppLastSession(appName, status, fields, {
          token: token
        });
      });
      _defineProperty(_assertThisInitialized(_this), "handleReload", function () {
        var appLastSessionActions = _this.props.appLastSessionActions;
        var token = _this.props.impersonate.token;
        appLastSessionActions.getAppLastSession(appName, {
          token: token
        });
      });
      return _this;
    }
    _createClass(withAppLastSessionComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var appLastSessionActions = this.props.appLastSessionActions;
        var token = this.props.impersonate.token;
        appLastSessionActions.getAppLastSession(appName, {
          token: token
        });
      }
    }, {
      key: "render",
      value: function render() {
        var appLastSessionActions = _objectSpread(_objectSpread({}, this.props.appLastSessionActions), {
          editAppLastSession: this.handleEditAppLastSession,
          reload: this.handleReload
        });
        return React.createElement(WrappedComponent, _extends({}, this.props, {
          appLastSessionActions: appLastSessionActions
        }));
      }
    }]);
    return withAppLastSessionComponent;
  }(Component);
  if (WrappedComponent.loadInitialData) {
    withAppLastSessionComponent.loadInitialData = WrappedComponent.loadInitialData;
  }
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      appLastSessionActions: bindActionCreators({
        getAppLastSession: getAppLastSession,
        editAppLastSessionField: editAppLastSessionField,
        fetchAppUpdateLastSession: fetchAppUpdateLastSession,
        editAndUpdateAppLastSession: editAndUpdateAppLastSession
      }, dispatch)
    };
  };
  var mapStateToProps = function mapStateToProps(state) {
    if (!state.hasOwnProperty('impersonate')) {
      throw new Error('Error in withLifeLine: "impersonate" is a required reducer');
    }
    var lastSession = state.apps.lastSessions.find(function (_ref) {
      var id = _ref.id;
      return id === appName;
    });
    var value = lastSession ? lastSession : {
      id: appName,
      fetching: false,
      fetched: false,
      model: {
        id: null,
        created: new Date().toISOString(),
        updated: new Date().toISOString(),
        status: 'uncompleted',
        application: {
          id: appName,
          description: '',
          type: 'forms'
        },
        items: []
      }
    };
    return {
      impersonate: state.impersonate,
      user: state.user.user,
      appLastSessionProps: value
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(withAppLastSessionComponent);
}